import { NgModule } from '@angular/core';
import { OrderStatusPipe } from 'src/app/shared/pipes/order-status.pipe';
import { SharedModule } from 'src/app/shared/shared.module';
import { OrderDisplayRoutingModule } from './order-display-routing.module';
import { OrderDisplayComponent } from './order-display.component';

@NgModule({
  declarations: [
    OrderDisplayComponent,
    OrderStatusPipe,
  ],
  imports: [
    OrderDisplayRoutingModule,
    SharedModule.forRoot(),
  ],
  exports: [OrderDisplayComponent],
  providers: [],
})
export class OrderDisplayModule { }
